import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="bg-olive-dark" data-id="element-63">
      {/* Final CTA Section */}
      <div className="py-24 md:py-32 px-4 flex flex-col items-center justify-center text-center" data-id="element-64">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="font-serif italic text-white text-3xl md:text-5xl lg:text-6xl mb-10 md:mb-14 leading-tight" data-id="element-65">
          Hacé clic y empezá hoy.
        </motion.h2>

        <motion.a href="#comprar" initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} whileHover={{
        scale: 1.04
      }} whileTap={{
        scale: 0.97
      }} className="inline-flex items-center gap-3 bg-white text-olive-dark px-12 py-5 rounded-full text-base md:text-lg font-bold uppercase tracking-[0.2em] shadow-xl hover:shadow-2xl transition-shadow" data-id="element-66">
          Acceder ahora
          <span className="text-xl" data-id="element-67">→</span>
        </motion.a>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 py-8 px-4" data-id="element-68">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 text-white/50 text-sm" data-id="element-69">
          <div className="flex items-center gap-2" data-id="element-70"></div>

          <p data-id="element-71">
            &copy; {new Date().getFullYear()} Sistema PRO. Todos los derechos
            reservados.
          </p>

          <div className="flex gap-6" data-id="element-72"></div>
        </div>
      </div>
    </footer>;
}